<template>
    <div id="app">
        <input-bar />
        <div id="appversion">
            {{Version}}
        </div>
    </div>
</template>

<script>
import InputBar from "./components/InputBar.vue";
import VersionNumber from './version.json'

export default {
    name: "app",
    components: {
        InputBar
    },
    computed: {
        Version() {
            return `${VersionNumber.Major}.${VersionNumber.Minor}.${VersionNumber.Build}`;
        }
    }
}
</script>

<style>
body {
    display: table;
    position: absolute;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    font-family: "Helvetica Neue", "Segoe UI", Helvetica, Arial, "Lucida Grande",
        sans-serif;
}

html {
    overflow: hidden;
}

html::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: #fff url(assets/ReceiverFullScreenBackground.jpg) center center
        fixed no-repeat;
    background-size: cover;
    filter: blur(2px);
    transform: scale(1.1);
}

#app {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    box-sizing: border-box;
}

#appversion {
    position: fixed;
    bottom: 4px;
    right:4px;
    color: rgba(207, 199, 186, 0.3);
    font-family: sans-serif;
    font-size: 10px;
    user-select: none;
    cursor: default;
}
</style>
